import React from 'react';
import ReactTable from 'react-table'
import Axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SearchBar from 'components/common/SearchBar'
import DatatableHelper from 'utils/DatatableHelper'
import { Colors, Sizes, ButtonGroup, Button} from 'react-foundation'
import { API } from 'api/APIClient'
import TableContainer from 'components/common/TableContainer'
import AppComponent from 'components/common/AppComponent'
import { NotificationManager } from "react-notifications"
import StandardModal from 'components/common/StandardModal'
import {Link} from "react-router-dom";
import DateHelper from 'utils/DateHelper'
import Modal from "react-responsive-modal";
import {CommonUtil} from "../../utils/CommonUtil";
import ReactSelect from "../common/ReactSelect";

class ChatFlowsTable extends AppComponent {

    constructor(props) {
        super(props);

        this.state = {
            items: [],
            searchKey: "",
            page: 0,
            pageSize: props.pageSize || 10,
            sorted: [{id: "id", "desc": true}],
            totalPages: -1,
            isLoading: true,
            pluginCompatible : props.pluginCompatible,
            modal: {
                isOpen: false,
                content: null,
                isUploading: false,
                error: null
            },
            filtersAreOpen: false
        };

        this.searchTimer = null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.pluginCompatible !== prevProps.pluginCompatible) {
            this.setState({
                pluginCompatible : this.props.pluginCompatible
            }, () => {
                this.fetchItems();
            });
        }
    }

    searchTextDidChange(newValue) {
        this.setState({
            searchKey: newValue || ""
        }, () => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.fetchItems();
            }, 1000);
        });
    }

    setPluginCompatibilityFilter = (value) => {
        this.setState({
            pluginCompatible : value
        }, () => {
            this.fetchItems();
        });
    }

    fetchItems = () => {
        this.setState({
            loading: true
        });

        Axios
            .post(API.chat.getChatFlowsDT, {
                    page: this.state.page,
                    pageSize: this.state.pageSize,
                    sorted: this.state.sorted,
                    filters: {
                        search: this.state.searchKey,
                        pluginCompatible : this.state.pluginCompatible === 1 ? 1 : undefined
                    }
                }
            )
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        items: res.data.data.rows,
                        totalPages: DatatableHelper.getTotalPages(res.data.data),
                        isLoading: false
                    }, () => {
                        if (this.props.onDidFetch instanceof Function) {
                            this.props.onDidFetch();
                        }
                    })
                }
                else {
                    this.setState({
                        isLoading: false
                    })
                }
            })
    }


    toggleRow = (item) => {
        if (this.props.onSelectedRow instanceof Function) {
            this.props.onSelectedRow(item);
        }
    }

    toggleSelectAll = () => {
        if (this.props.onSelectedAll instanceof Function) {
            this.props.onSelectedAll(!this.props.selectAll, this.state.items);
        }
    }

    showDeleteModal = (item) => {

        console.log(item);

        if (!this.state.modal.isOpen) {
            console.log("in");
            const content = (
                <StandardModal
                    title="Delete Chat Flow"
                    content={(
                        <div>Are you sure to delete <strong>{item.title}</strong> chat flow ? This action cannot be reverted.</div>
                    )}
                    buttons={(
                        <React.Fragment>
                                <button className="button secondary" type="button" onClick={this.closeModal}>
                                    Cancel
                                </button>
                                <button className="button alert" type="button" onClick={() => this.handleDeleteItem(item)}>
                                    Delete
                                </button>
                        </React.Fragment>
                    )}
                    isUploading={this.state.modal.isUploading}
                />
            );

            this.setState({
                modal: Object.assign({}, this.state.modal, {
                    isOpen: true,
                    content: content,
                    size: "modal-medium"
                })
            })
        }
    }

    closeModal = (completion) => {
        if (this.state.modal.isOpen) {
            this.setState({
                modal: {
                    isOpen: false,
                    content: null
                }
            }, () => {
                if (completion instanceof Function) {
                    completion();
                }
            })
        }
    }

    handleDeleteItem = (item) => {

        if (!this.state.modal.isUploading) {
            this.setState({
                modal: Object.assign({}, this.state.modal, {
                    isUploading: true
                })
            }, () => {

                Axios
                    .post(API.chat.deleteChatFlow, {
                        id: item.id
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.closeModal(() => {
                                this.fetchItems();
                                NotificationManager.success("Chat Flow deleted");
                            });
                        }
                        else {
                            this.closeModal(() => {
                                NotificationManager.error(res.data.error.desc);
                            });
                        }
                    })
                    .catch(error => {
                        this.closeModal(() => {
                            NotificationManager.error(error.response);
                        });
                    });
            })
        }
    }

    render() {

        const columns = [
            {
                id: "checkbox",
                accessor: "",
                Cell: row => {
                    return (
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={this.props.selected.find((o) => o.id === row.original.id) ? true : false}
                            onChange={() => this.toggleRow(row.original)}
                        />
                    );
                },
                Header: () => {
                    if (this.props.isSingleSelection) {
                        return null;
                    }
                    else {
                        return (
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={this.props.selectAll}
                                onChange={this.toggleSelectAll}
                            />
                        );
                    }
                },
                sortable: false,
                width: 45,
                show: this.props.isSelector || false
            },
            {
                Header: 'ID',
                accessor: 'id',
                maxWidth: 60
            },
            {
                Header: "Title",
                accessor: "title"
            },
            {
                Header: "Pinned",
                accessor: "pinned",
                Cell: row => {
                    return row.value === 1 ? "Yes" : "No";
                }
            },
            {
                Header: "Pinned Order",
                accessor: "pinnedOrder",
                Cell: row => {
                    return row.original.pinned === 1 ? row.value : "n/a";
                }
            },
            {
                Header: "Quick access",
                accessor: "isQuickAccess",
                Cell: row => {
                    return row.value === 1 ? "Yes" : "No";
                }
            },
            {
                Header: "QA Order",
                accessor: "qaOrder",
                Cell: row => {
                    return row.original.isQuickAccess === 1 ? row.value : "n/a";
                }
            },
            {
                Header: "Plugin Compatible",
                accessor: "pluginCompatible",
                Cell: row => {
                    return row.original.pluginCompatible === 1 ? "Yes" : "No";
                }
            },
            {
                Header: "InApp Title",
                accessor: "inAppTitle"
            },
            {
                Header: "InApp Subtitle",
                accessor: "inAppSubtitle"
            },
            {
                Header: 'Created At',
                accessor: 'createdAt',
                maxWidth: 180,
                Cell: row => {
                    return DateHelper.convertToLocalDateTime(row.value);
                }
            },
            {
                Header: 'Actions',
                Cell: row => (
                    <ButtonGroup size={Sizes.TINY}>
                        <Link
                            style={{marginRight: 5}}
                            to={{
                                pathname: "/chatFlows/edit",
                                state: {
                                    permissions: this.context.permissions.chatFlows,
                                    item: {
                                        duplicateID: row.original.id
                                    }
                                }
                            }}
                        >
                            <Button color={Colors.PRIMARY}>Clone</Button>
                        </Link>
                        <Link
                            style={{marginRight: 5}}
                            to={{
                                pathname: "/chatFlows/edit",
                                state: {
                                    permissions: this.context.permissions.chatFlows,
                                    item: row.original
                                }
                            }}
                        >
                            <Button color={Colors.PRIMARY}><FontAwesomeIcon icon="edit" /></Button>
                        </Link>
                        <Button color={Colors.ALERT} onClick={() => this.showDeleteModal(row.original)}><FontAwesomeIcon icon="trash" /></Button>
                    </ButtonGroup>
                ),
                maxWidth: 180,
                sortable: false,
                className: "center",
                show: !this.props.isSelector && (this.context.permissions.chatFlows.edit || this.context.permissions.chatFlows.delete)
            }
        ]

        const table = (
            <ReactTable
                columns={columns}
                data={this.state.items}
                pages={this.state.totalPages}
                pageSize={this.state.pageSize}
                loading={this.state.isLoading}
                multisort={true}
                manual
                className='-striped'
                onFetchData={(state) => {
                    this.setState({
                        page: state.page,
                        pageSize: state.pageSize,
                        sorted: state.sorted
                    }, () => {
                        this.fetchItems()
                    })
                }}
            />
        );

        const filters = (
            <React.Fragment>
                <div className="cell small-12 medium-6 large-3">
                    <span>Search</span>
                    <SearchBar
                        onDidChange={(newValue) => this.searchTextDidChange(newValue)}
                    />
                </div>

                <div className="cell small-12 medium-6 large-3">
                    <span>Plugin Compatibility</span>
                    <ReactSelect
                        name="pluginCompatible"
                        className="react-select"
                        onChange={(e) => this.setPluginCompatibilityFilter(e.target.value)}
                        value={this.state.pluginCompatible}
                        options={[
                            { label : "Show incompatible", value : 0 },
                            { label : "Show only compatible", value : 1 }
                        ]}
                    />
                </div>
            </React.Fragment>
        )

        const buttons = (
            <React.Fragment>
                {this.context.permissions.chatFlows.create && !this.props.isSelector &&
                    <React.Fragment>
                        <Link
                            to={{
                                pathname: "/chatflows/import",
                            state: {
                                permissions: this.context.permissions.chatFlows
                            }
                        }}
                    >
                        <button type="button" className="button small" >Import Chat Flows</button>
                    </Link>
                    <Link
                        to={{
                            pathname: "/chatflows/triggers",
                            state: {
                                permissions: this.context.permissions.chatFlows
                            }
                        }}
                    >
                        <button type="button" className="button small" >Configure triggers</button>
                    </Link>
                    <Link
                        to={{
                            pathname: "/chatflows/tinyHabits",
                            state: {
                                permissions: this.context.permissions.chatFlows
                            }
                        }}
                    >
                        <button type="button" className="button small" >Tiny Habits</button>
                    </Link>
                    <Link
                        to={{
                            pathname: "/chatFlows/aiPrompts",
                            state: {
                                permissions: this.context.permissions.chatFlows
                            }
                        }}
                    >
                        <button type="button" className="button small" >Manage Prompts</button>
                    </Link>
                    <Link
                        to={{
                            pathname: "/chatflows/create",
                            state: {
                                permissions: this.context.permissions.chatFlows
                            }
                        }}
                    >
                        <button type="button" className="button small" >Add New Chat Flow</button>
                    </Link>
                </React.Fragment>
                }
            </React.Fragment>
        )

        return (
            <React.Fragment>
                <TableContainer
                    title="Chat Flows table"
                    buttons={buttons}
                    filters={filters}
                    table={table}
                />
                <Modal
                    classNames={{modal: this.state.modal.size}}
                    open={this.state.modal.isOpen}
                    modalId="ChatFlowsTableModal"
                    onClose={this.closeModal}
                    center
                >
                    {this.state.modal.content}
                </Modal>
            </React.Fragment>
        );
    }
}

export default ChatFlowsTable;